import React, { useContext, useEffect } from "react";
import { BsMusicNoteBeamed, BsChevronRight, BsCheckCircleFill, BsThreeDotsVertical } from "react-icons/bs";
import "../../../../assets/css/components/aiContent/AudioSection.css";
import AppContext from "../../../../context/AppContext";

const AudioCard = ({ item, selectedVoice, setSelectedVoice }) => {
  const isSelected = selectedVoice?.voice_id === item.voice_id;

  return (
    <div
      className={`es-audio-card-row ${isSelected ? "es-audio-selected" : ""}`}
      onClick={() => {
        console.log("Voice Clicked:", item);
        setSelectedVoice(item);
      }}
    >
      <span className="es-audio-check">
        <BsCheckCircleFill />
      </span>

      <span className="es-audio-name">{item.name}</span>

      <div className="es-audio-waveform-mini">
        {[6, 12, 9, 16, 10, 14, 7, 13, 9].map((h, i) => (
          <span key={i} className="es-wave-bar" style={{ height: `${h}px` }} />
        ))}
      </div>

      <audio
        src={item.preview_audio_url}
        controls
        className="es-audio-native"
        onClick={(e) => e.stopPropagation()}
      />

      <span className="es-audio-menu">
        <BsThreeDotsVertical />
      </span>
    </div>
  );
};

const AudioSection = ({ voice }) => {
  const { selectedVoice, setSelectedVoice } = useContext(AppContext);

  useEffect(() => {
    console.log("Selected Voice:", selectedVoice);
  }, [selectedVoice]);

  return (
    <div className="es-section-block es-audio-block">
      <div className="es-section-header">
        <div className="es-section-title-group">
          <span className="es-section-icon-wrap es-icon-wrap-audio">
            <BsMusicNoteBeamed />
          </span>

          <div>
            <h4 className="es-section-title">Audio</h4>
            <p className="es-section-desc">
              Manage AI-generated voice audio, accents and languages.
            </p>
          </div>
        </div>

        <BsChevronRight className="es-section-chevron" />
      </div>

      {!voice ? (
        <div className="es-empty-state">Loading...</div>
      ) : (
        <AudioCard
          item={voice}
          selectedVoice={selectedVoice}
          setSelectedVoice={setSelectedVoice}
        />
      )}
    </div>
  );
};

export default AudioSection;